(function () {
  class SbCollectionCarousel {
    sectionId = document.currentScript.dataset.id;
    config = {
      navigation: {
        nextEl: `#sb-collection-carousel-next-${this.sectionId}`,
        prevEl: `#sb-collection-carousel-prev-${this.sectionId}`,
      },
      slidesPerView: 4,
      spaceBetween: 30,
      slideActiveClass: "active",
      loop: true,
      breakpoints: {
        200: {
          slidesPerView: 1,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    };
    swiper = new Swiper(
      `#sb-collection-carousel-${this.sectionId}`,
      this.config
    );

    constructor() {
      this.init();
    }

    init() {
      this.cacheDOM();
      this.events();
    }

    cacheDOM() {}

    events() {}
  }

  new SbCollectionCarousel();
})();
